<template>
  <div>
    <div class="advanceParent">
      <app-history
        @clicked="showDialog = true"
        class="advancedSearch"
        title="جستجوی پیشرفته"
      />
    </div>
    <div>
      <v-data-table
        :items="orders"
        :headers="ordersHeaders"
        class="elevation-1 rounded"
        :server-items-length="totalCount"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
          itemsPerPageOptions: [10],
        }"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
        @pagination="doPage"
      >
        <template v-slot:[`item.foodPrice`]="{ item }">
          {{ Number(item.foodPrice).toLocaleString() }}
        </template>

        <template v-slot:[`item.sabtDate`]="{ item }">
          {{ convertDate(item.sabtDate) }}
        </template>
        <template v-slot:[`item.deliveryDate`]="{ item }">
          {{
            item.deliveryDate != null ? convertDate(item.deliveryDate) : "ندارد"
          }}
        </template>
        <template v-slot:[`item.kprice`]="{ item }">
          {{ GetKprice(item.kprice) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ GetStatus(item.status) }}
        </template>
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }"
          >از {{ pageStart }} تا {{ pageStop }}</template
        >
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ شروع: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="StartDate"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ پایان: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="EndDate"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="GetUserOrders"
          :disabled="apiRunning"
        >
          جستجو
        </v-btn>
        <v-btn
          color="red white--text"
          class="dialogButton"
          rounded
          @click="clearFilter"
          :disabled="apiRunning"
        >
          پاک کردن
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <date-picker
      ref="datepicker1"
      v-model="StartDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate($event, 1)"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker
      ref="datepicker2"
      v-model="EndDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      @change="onChangeDate($event, 2)"
    ></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetUserOrders } from "@/api/orders";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      orders: [],

      StartDate: "",
      EndDate: "",
      totalCount: 0,
      ordersHeaders: [
        {
          text: "غذا",
          value: "foodName",
          width: "10%",
        },
        {
          text: "قیمت (ریال)",
          value: "foodPrice",
          width: "5%",
        },
        {
          text: "تعرفه",
          value: "kprice",
          width: "5%",
        },
        {
          text: "تعداد سفارش",
          value: "numberOrder",
          width: "5%",
        },
        {
          text: "تاریخ سفارش",
          value: "sabtDate",
          width: "10%",
        },
        {
          text: "تاریخ وعده",
          value: "tarikh",
          width: "10%",
        },
        {
          text: "تاریخ تحویل",
          value: "deliveryDate",
          width: "10%",
        },
        {
          text: "مکان تحویل",
          value: "deliveryPlaceName",
          width: "10%",
        },
        {
          text: "وضعیت",
          value: "status",
          width: "10%",
        },
      ],
    };
  },
  created() {
    if (this.currentRole) this.GetUserOrders();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentRole() {
      return this.$store.getters.currentRole;
    },
  },

  methods: {
    doPage($event) {
      this.GetUserOrders(($event.page - 1) * 10);
    },
    onChangeDate($event, input) {
      if (input == 1) {
        this.StartDate = $event.format("jYYYY/jMM/jDD");
      } else {
        this.EndDate = $event.format("jYYYY/jMM/jDD");
      }
    },
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    clearFilter() {
      this.StartDate = "";
      this.EndDate = "";
      this.GetUserOrders();
    },
    GetUserOrders(skip) {
      if (isNaN(skip)) skip = 0;
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetUserOrders(
          this.currentRole.BranchID,
          this.StartDate,
          this.EndDate,
          skip
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.orders = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);
            this.showDialog = false;

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    convertDate(date) {
      return moment(date).format("HH:mm jYYYY/jMM/jDD");
    },
    GetKprice(kprice) {
      switch (kprice) {
        case 1:
          return "طلبه";
        case 2:
          return "استاد";
        case 3:
          return "پرسنل";
        case 4:
          return "آزاد";
        case 5:
          return "سایر";
      }
    },
    GetStatus(status) {
      switch (status) {
        case 0:
          return "رزرو شده";
        case 1:
          return "تحویل گرفته شده";
        case 3:
          return "جریمه شده";
      }
    },
  },
};
</script>
<style>
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
</style>
